<template>
  <div class="technology-container">
    <!-- 顶部标题区域 -->
    <div class="title-section">
      <h1 class="main-title">技术平台</h1>
      <p class="subtitle">恒毅新生物建有国际先进的多技术平台，助力基因编辑产品的开发和应用</p>
    </div>

    <!-- 技术平台图片区域 -->
    <div class="platforms-grid">
      <div 
        v-for="(platform, index) in platforms" 
        :key="index" 
        class="platform-item"
        @click="handlePlatformClick(platform)"
      >
        <div class="platform-image">
          <img v-lazy="platform.image" :alt="platform.title" />
          <div class="platform-content">
            <h3 class="platform-title">{{ platform.title }}</h3>
            <ul class="platform-features">
              <li v-for="(feature, featureIndex) in platform.features" :key="featureIndex">
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TechnologyPlatform",
  data() {
    return {
      platforms: [
        {
          title: "NGS二代测序平台",
          image: require("../../assets/img/tech02.jpg"),
          link: "/platform/detail/48",
          features: [
            "多平台覆盖",
            "高通量与灵活性",
            "数据准确性高",
            "快速交付",
            "一站式服务"
          ]
        },
        {
          title: "荧光显微成像平台",
          image: require("../../assets/img/tech01.png"),
          link: "/platform/detail/50",
          features: [
            "ThermoFisher成像系统",
            "正置荧光显微镜", 
            "高灵敏度与高分辨率",
            "自动化与高通量",
            "可视化与数据处理"
          ]
        },
        {
          title: "数字PCR平台",
          image: require("../../assets/img/tech03.jpg"),
          link: "/platform/detail/49",
          features: [
            "绝对定量",
            "高灵敏度",
            "高阶多重",
            "强抗干扰",
            "灵活多用"
          ]
        },
        {
          title: "云数据分析平台",
          image: require("../../assets/img/tech04.png"),
          link: "/platform/detail/51",
          features: [
            "高性能计算",
            "超大储存",
            "自动化解读",
            "多流程集成",
            "定制化分析"
          ]
        }
      ]
    };
  },
  methods: {
    handlePlatformClick(platform) {
      if (platform.link) {
        this.$router.push(platform.link);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.technology-container {
  width: 100%;
  min-height: 100vh;
  padding: 9.25rem 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  gap: 2rem;
}

.title-section {
  text-align: center;
  height: 10rem;
  padding: 0 20px;
  
  .main-title {
    font-size: 2.5rem; // 48px -> 2.5rem
    font-weight: 600;
    color: #000;
    margin-bottom: 1.5625rem; // 25px -> 1.5625rem
    position: relative;
    padding-bottom: 1.25rem; // 20px -> 1.25rem

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: 0;
      width: 100px;
      height: 3px;
      background-color: #000;
    }
  }
  
  .subtitle {
    margin-top: 0.625rem; // 10px -> 0.625rem
    font-size: 1.25rem; // 20px -> 1.25rem
    color: #666;
    font-weight: 400;
    line-height: 1.5;
  }
}

.platforms-grid {
  display: flex;
  gap: 2rem;
  width: 100%;
  flex: 1;
  margin-bottom: 3rem;
  padding: 0 2rem;
  box-sizing: border-box;
}

.platform-item {
  flex: 1;
  cursor: pointer;
  transition: transform 0.3s ease;
  position: relative;
  width: 100%;
  padding-bottom: 6rem;

  &:hover {
    transform: translateY(-10px);
    
    .platform-content {
      background: rgba(0, 0, 0, 0.5);
    }
  }
}

.platform-image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  &:hover img {
    transform: scale(1.05);
  }
}

.platform-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  padding: 1.5rem;
  transition: all 0.3s ease;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // align-items: center;
}

.platform-title {
  color: #fff;
  font-size: 1.5rem; // 20px -> 1.25rem
  font-weight: 600;
  margin-bottom: 1rem;
  // text-align: center;
}

.platform-features {
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    color: #fff;
    font-size: 1rem; // 14px -> 0.875rem
    line-height: 1.6;
    margin-bottom: 0.5rem;
    padding-left: 1rem;
    position: relative;
    
    &::before {
      content: '•';
      color: #fff;
      position: absolute;
      left: 0;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .platforms-grid {
    flex-direction: column;
    gap: 1.5rem;
    padding: 0 1rem;
  }
  
  .platform-item {
    height: 350px;
  }
  
  .title-section {
    .main-title {
      font-size: 2rem; // 32px -> 2rem
    }
    
    .subtitle {
      font-size: 1rem; // 16px -> 1rem
    }
  }
  
  .platform-content {
    padding: 1rem;
  }
  
  .platform-title {
    font-size: 1.125rem; // 18px -> 1.125rem
  }
  
  .platform-features li {
    font-size: 0.8125rem; // 13px -> 0.8125rem
  }
}

// 小屏幕设备优化
@media (max-width: 480px) {
  .title-section {
    .main-title {
      font-size: 1.75rem; // 28px -> 1.75rem
    }
    
    .subtitle {
      font-size: 0.875rem; // 14px -> 0.875rem
    }
  }
  
  .platform-item {
    height: 300px;
  }
  
  .platform-content {
    padding: 0.75rem;
  }
  
  .platform-title {
    font-size: 1rem; // 16px -> 1rem
  }
  
  .platform-features li {
    font-size: 0.75rem; // 12px -> 0.75rem
  }
}
</style>
